import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import indiaflag from "svg-country-flags/svg/in.svg";
import USAflag from "svg-country-flags/svg/us.svg";
import UKflag from "svg-country-flags/svg/gb.svg";
import {SelectBroker} from "../../utils/constants";

import {
  Container,
  Row,
  Col,
  ListGroup,
  Form,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import CenteredModal from "components/common/modals/CenteredModal";
import ProfitChart from "assets/images/Profit-Chart.png";
import "./Steps.css";
import {InputCol, SearchDropdown, SelectCol} from "components/common/modals";
// import { showRegister } from "actions/auth";
import {hideSteps, showRegister, showSteps} from "actions/ui_control";

import DemoService from "services/demo";


// const SelectBroker = [
//   "Epislon",
//   "Interactive Brokers",
//   "Zerodha",
//   "Nuvama",
// ];

const initialState = {
  country: "United States",
  ticker: "",
  email: "",
  percent_down: "",
  order_max_quantity: "",
  total_max_quantity: "",
  max_amount: "",
  selectBroker: "",
};

function Steps({...props}) {
  const {user: userData} = useSelector(state => state.auth);
  const {isShowSteps} = useSelector(state => state.ui_control);
  const [stepNumber, setStepNumber] = useState(1);
  const [inputs, setInputs] = useState({...initialState});

  const dispatch = useDispatch();
  // const [selectedCountry, setSelectedCountry] = useState("United States");
  const [showCongrats, setShowCongrats] = useState(false);
  const handleChange = e => {
    const {name, value, type} = e.target;

    let newValue = value;
    if (type === "number") {
      const parsedNum = parseFloat(value);

      newValue = parsedNum ? parseFloat(value) : "";
    }

    // Use a callback to update each input change immediately
    setInputs(curInputs => ({...curInputs, [name]: newValue}));
  };
  const handleDropdownChange = ({name, value}) => {
    // Use a callback to update each input change immediately
    setInputs(curInputs => ({...curInputs, [name]: value}));
  };
  const setStep = number => {
    setStepNumber(number);
    if (number > 4) {
      setShowCongrats(true);
    }
  };

  // Event handler for country selection
  const handleCountrySelect = (country) => {
    console.log("Selected Country:", country);
    setInputs((curInputs) => ({...curInputs, country}));

    // Filter SelectBroker based on the selected country
    const filteredBrokers = SelectBroker[country] || [];
    setInputs((curInputs) => ({...curInputs, selectBroker: ""}));
    setFilteredBrokers(filteredBrokers);
  };

  // Array to store filtered brokers based on the selected country
  const [filteredBrokers, setFilteredBrokers] = useState(SelectBroker[initialState.country] || []);

  const handleStockSelect = ticker => {
    setInputs(curInputs => ({...curInputs, ticker}));
  };


  const handleSubmit = async () => {
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    try {
      if (inputs.email.match(validRegex)) {
        const res = await DemoService.sendForm(inputs);
      }
    } catch (error) {
    }
    handleClose();
    dispatch(showRegister());
  };
  const showStepsFunc = () => {
    dispatch(showSteps());
  };
  const hideStepsFunc = () => {
    dispatch(hideSteps());
  };
  const handleClose = () => {
    setInputs({...initialState});
    hideStepsFunc();
    // setStepNumber(1);
    // setShowCongrats(false);
  };
  // Content based on steps
  let stepContent;
  switch (stepNumber) {
    case 1:
      stepContent = (
        <>
          <Col sm={12} lg={5} className="highlighted-card">
            <h3 className="mb-4">Smart Investing </h3>
            <span className="mb-0">
              No missed opportunities. Monitor and Buy 1000's of stocks/ETF's.
            </span>
            <ul className="mb-0">
              <li>Stock price goes down</li>
              <li>Maximum amount that you want to invest</li>
              <li>Order quantity to buy each time</li>
              <li>Total quantity to purchase over time</li>
              {/*<li></li>*/}
            </ul>
          </Col>
          <Col
            sm={12}
            lg={5}
            className="d-flex align-items-center mt-4 mt-lg-0 px-0 px-sm-2"
          >
            <div className="d-flex flex-column w-100">
              <p className="">To start, select your country</p>
              <ListGroup
                horizontal
                className="justify-content-between gap-1 gap-sm-3 gap-md-2 gap-xl-3"
              >
                <ListGroup.Item
                  active={inputs.country === "United States"}
                  onClick={() => handleCountrySelect("United States")}
                  action
                  className={` country-button rounded ${
                    inputs.country === "United States" &&
                    "country-button-active"
                  }`}
                >
                  <img
                    src={USAflag}
                    className="country-flag"
                    style={{borderRadius: "2px"}}
                  />{" "}
                  USA
                </ListGroup.Item>
                <ListGroup.Item
                  active={inputs.country === "United Kingdom"}
                  onClick={() => handleCountrySelect("United Kingdom")}
                  action
                  className={` country-button rounded ${
                    inputs.country === "United Kingdom" &&
                    "country-button-active"
                  }`}
                >
                  <img
                    src={UKflag}
                    className="country-flag"
                    style={{borderRadius: "2px"}}
                  />{" "}
                  UK
                </ListGroup.Item>
                <ListGroup.Item
                  active={inputs.country === "India"}
                  onClick={() => handleCountrySelect("India")}
                  action
                  className={` country-button rounded ${
                    inputs.country === "India" && "country-button-active"
                  }`}
                >
                  <img
                    src={indiaflag}
                    className="country-flag"
                    style={{borderRadius: "2px"}}
                  />{" "}
                  India
                </ListGroup.Item>
              </ListGroup>
            </div>
          </Col>
        </>
      );
      break;
    case 2:
      stepContent = (
        <>
          {" "}
          <Col sm={12} lg={5} className="highlighted-card d-grid">
            <h3 className="mb-4">Stock</h3>
            <p className="">Choose the stock you want to buy</p>
            <SearchDropdown
              country={inputs.country}
              label=""
              marginBottom="mb-0"
              name={"ticker"}
              placeholder={"Select Stock"}
              value={inputs.ticker}
              handleChange={handleChange}
              isValidate={true}
              isFullWidth={true}
            />
          </Col>
          <Col sm={12} lg={5} className="highlighted-card d-grid mt-4 mt-lg-0">
            <h3 className="mb-4">Percent Down</h3>
            <p className="">Buy when the stock falls by a percentage</p>
            <Form.Control
              type="number"
              aria-label="number input"
              placeholder="0"
              className="mt-auto"
              name="percent_down"
              value={inputs.percent_down}
              onChange={handleChange}
            />
          </Col>
        </>
      );
      break;
    case 3:
      stepContent = (
        <>
          <Col sm={12} lg={5} className="highlighted-card d-grid">
            <h3 className="mb-4">Quantity per order </h3>
            <p className="">
              How much of the stock shall we buy when the stock falls.
            </p>
            <Form.Control
              type="number"
              aria-label="number input"
              placeholder="1"
              className="mt-auto"
              name="order_max_quantity"
              value={inputs.order_max_quantity}
              onChange={handleChange}
            />
          </Col>
          <Col sm={12} lg={5} className="highlighted-card d-grid mt-4 mt-lg-0">
            <h3 className="mb-4">Max quantity</h3>
            <p className="">
              Total quantity you would like to purchase over time.
            </p>
            <Form.Control
              type="number"
              aria-label="number input"
              placeholder="0"
              className="mt-auto"
              name="total_max_quantity"
              value={inputs.total_max_quantity}
              onChange={handleChange}
            />
          </Col>
        </>
      );
      break;
    case 4:
      stepContent = (
        <>
          <Col sm={12} lg={5} className="highlighted-card d-grid">
            <h3 className="mb-4">Total amount </h3>
            <p className="">
              Total amount you want to invest in the stock overall.
            </p>
            <Form.Control
              type="number"
              aria-label="number input"
              placeholder="0"
              className="mt-auto"
              name="max_amount"
              value={inputs.max_amount}
              onChange={handleChange}
            />
          </Col>
          <Col sm={12} lg={5} className="highlighted-card  mt-4 d-grid mt-lg-0">
            <h3 className="mb-4">Broker</h3>
            <p className="">Select your broker.</p>

            <DropdownButton
              className="form-dropdown d-flex flex-column align-items-end justify-content-end"
              id={"selectBroker"}
              name={"selectBroker"}
              value={inputs.selectBroker}
              onSelect={value =>
                handleDropdownChange({name: "selectBroker", value})
              }
              title={
                inputs.selectBroker.length > 0
                  ? inputs.selectBroker
                  : "Select Broker"
              }
              variant="custom"
            >
              {filteredBrokers.map((option, i) => (
                <Dropdown.Item className="p-3" eventKey={option} key={i}>
                  {option}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </Col>
        </>
      );
      break;
  }

  const content = (
    <Container>
      <Row>
        {/* Step indicator section */}
        <Col sm={12} className="text-center">
          <h4
            style={{
              fontStyle: "normal",
              fontWeight: "600",
              fontSize: "20px",
              lineHeight: "20px",
              marginRight: "10px",
              marginTop: "30px",
              marginBottom: "10px",
            }}
          >
            STEP {stepNumber} OF 4
          </h4>
        </Col>
        {/* Steps Overview */}
        <Col sm={12} className="text-center mb-4 d-flex justify-content-center">
          <div className="steps-container">
            <div className={stepNumber >= 1 ? "dot active" : "dot"}></div>
            <div className={stepNumber >= 1 ? "line active" : "line"}></div>
            <div className={stepNumber >= 2 ? "dot active" : "dot"}></div>
            <div className={stepNumber >= 2 ? "line active" : "line"}></div>
            <div className={stepNumber >= 3 ? "dot active" : "dot"}></div>
            <div className={stepNumber >= 3 ? "line active" : "line"}></div>
            <div className={stepNumber >= 4 ? "dot active" : "dot"}></div>
          </div>
        </Col>

        {/* Step Content */}
        <Col sm={12} className="px-lg-0 mt-4">
          <Row className="d-flex justify-content-evenly">
            {stepContent}
            <Col sm={12} className="d-flex mt-4 mb-3 ">
              {stepNumber > 1 && (
                <a
                  onClick={() => {
                    setStep(stepNumber - 1);
                  }}
                  className="me-auto"
                >
                  <i className="bi bi-arrow-left"></i> Back
                </a>
              )}
              <a
                onClick={() => {
                  setStep(stepNumber + 1);
                }}
                className="ms-auto"
              >
                Next Step <i className="bi bi-arrow-right"></i>
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );

  const congratsContent = (
    <Container>
      <Row>
        {/* Header section */}
        <Col sm={12} className="modal-header congrats px-2">
          <h3 className="mt-4 mb-3">Congrats!</h3>
          <p>
            You have just added your first stock!
            <br/>
            Let's see what happens and we will inform you about results.
          </p>
          <img src={ProfitChart} style={{}} alt="profit-chart"/>
          <InputCol
            label="Email"
            name={"email"}
            type="text"
            value={inputs.email}
            handleChange={handleChange}
            colClass="mb-3 px-0 pe-lg-2"
            placeholder="Email"
            isFullWidth={true}
          />
          <div className="form-group pt-2 pb-2 mt-3">
            <button
              className="btn btn-primary btn-block btn-full"
              onClick={handleSubmit}
            >
              Sign Up! It's free!
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );

  // const handleClose = () => {
  //   setShow(false);
  // };

  return (
    <CenteredModal
      show={isShowSteps}
      setShow={hideStepsFunc}
      // onHide={handleClose}
      bodyContent={showCongrats ? congratsContent : content}
      // isStatic={true}
      size={showCongrats ? "md" : "xl"}
      // showReturnArrow={stepNumber > 1}
      // onReturnArrowClick={() => { setStep(stepNumber - 1) }}
    />
  );
}

export default Steps;
